(function () {
    'use strict';

    angular
        .module('styleVisualGuidelinesControllers')
        .controller('VisualGuidelinesStyleController', Controller);

    Controller.$inject = ['$scope', 'topBarService'];

    function Controller($scope, topBarService) {
        topBarService.setModule('Visual Guidelines');
        topBarService.setTitleAndIcon('Style', 'fa fa-codepen');
    }
})();